var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('PieChartBase',{ref:"chartCanvas",attrs:{"chartData":_vm.dataSet,"options":_vm.options,"height":250}})
}
var staticRenderFns = []

export { render, staticRenderFns }